"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const Language_1 = __importDefault(require("../Language"));
const globalVariables_1 = require("../../../../common/globalVariables");
const LanguagePageWrapper = styled_components_1.default.div `
  width: ${(props) => props.styleForSettingsPage ? "auto" : props.modalWidth}px;
  min-height: 440px;
  margin: ${(props) => (props.styleForSettingsPage ? " initial" : "0 auto")};
  padding: 20px 0;

  @media (max-width: 1000px) {
    width: auto;
    padding: 20px;
  }

  .MuiButtonBase-root {
    padding: 8px 0;
  }

  .MuiListItemIcon-root {
    min-width: auto;
  }
`;
const LanguagePage = (props) => {
    const { enabledLocales, isLoadedFromSettingPage } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(LanguagePageWrapper, { modalWidth: globalVariables_1.WEB_APP.MAX_WIDTH_CONTAINER, styleForSettingsPage: isLoadedFromSettingPage },
            react_1.default.createElement(Language_1.default, { enabledLocales: enabledLocales }))));
};
const mapStoreToProps = (store) => ({
    enabledLocales: store.getValue("enabledLocales"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(LanguagePage);
